/** Full-screen Gemini property search assistant (replaces legacy AISearchPage routes). */
export const PROPERTY_SEARCH_ASSISTANT_PATH = '/assistant';
